export function lockChrome(): void {
  const prevent = (event: Event) => event.preventDefault()
  document.addEventListener('gesturestart', prevent)
  document.addEventListener('gesturechange', prevent)
  document.addEventListener('gestureend', prevent)
  document.addEventListener('contextmenu', prevent)
  document.addEventListener('dblclick', prevent)
  document.addEventListener('selectstart', prevent)
  document.addEventListener(
    'touchmove',
    (event: TouchEvent) => {
      if (event.touches.length > 1) event.preventDefault()
    },
    { passive: false },
  )
}
